<template>
  <RIMomentoEscuela :escuela="1" titulo="Reporte RI al momento INBI" />
</template>

<script>
import RIMomentoEscuela from '@/views/kpi/RIMomentoEscuela.vue'

export default {
  name: 'RIMomentoINBI',
  components: { RIMomentoEscuela },
}
</script>
